import { RootState } from '../reducers';
import { Product } from '../apiTypes';
import { Selector } from '@reduxjs/toolkit';

export const selectProductsData: Selector<RootState, Product[]> = (
  state,
) => state.product.productsData;
